import { useEffect } from "react";
import Assinaturas from "../../components/Assinaturas";
import { DadosContainerDefault } from "../../components/Styles";

function AssinaturasPage() {
  useEffect(() => {
    document.title = 'Assinaturas | Gesttor'
  }, [])

  return (
    <DadosContainerDefault>
      <Assinaturas />
    </DadosContainerDefault>
  )
}

export default AssinaturasPage;